import { Button, Checkbox, Col, Form, Input, InputNumber, Layout, Row } from 'antd';
import React, { useEffect } from 'react'
import { Add_Category_Api } from '../../API/CategoryApi';
import { SaveOutlined, RollbackOutlined, CheckOutlined } from '@ant-design/icons';
// =================================================================
export const AddCategoryComponent = ({ setLoading, showMessage, parentId, parentTitle, rowInserted, cancelInsert }) => {
    // =================================================================
    const [form] = Form.useForm()
    // =================================================================
    useEffect(() => {
        form.setFieldsValue({ isActive: true });
    }, [parentId]);
    // =================================================================
    const onSubmit = async (values) => {
        try {
            values.parentId = parentId;
            values.parentTitle = "";
            setLoading(true);
            let data = await Add_Category_Api(values);
            setLoading(false);
            rowInserted();
            if (data.messageStatus == "Successful")
                showMessage(data.message, "Successful")
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        showMessage(errorInfo, "error")
    };
    // =================================================================
    return (
        <>
            <div className='sectionTitle'>
                <h2 >
                    افزودن زیر دسته برای {parentTitle}
                </h2>
            </div>

            <div className='container'>

                <Form
                    name="basic"
                    form={form}
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 20 }}
                    onFinish={onSubmit}
                    onFinishFailed={onFinishFailed}
                >
                    <Form.Item
                        name="id"
                        hidden={true}
                    >
                    </Form.Item>

                    <Form.Item
                        name="title"
                        label="عنوان"
                        rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                    >
                        <Input placeholder='عنوان' />
                    </Form.Item>

                    <Form.Item
                        name="comment"
                        label="شرح"
                        rules={[{ message: 'یک مقدار معتبر وارد کنید!' }]}
                    >
                        <Input placeholder='شرح' />
                    </Form.Item>

                    <Form.Item
                        name="parentId"
                        hidden={true}
                    >
                    </Form.Item>
                    <Form.Item
                        name="parentTitle"
                        hidden={true}
                    >
                    </Form.Item>

                    <Form.Item
                        name="showInPeriod"
                        label="نمایش در دوره های رزرو"
                        valuePropName='checked'
                    >
                        <Checkbox > </Checkbox>
                    </Form.Item>

                    <Form.Item
                        name="showInPrice"
                        label="نمایش در قیمت گذاری"
                        valuePropName='checked'
                    >
                        <Checkbox > </Checkbox>
                    </Form.Item>

                    <Form.Item
                        name="showInFoodPeriod"
                        label="نمایش در دوره غذایی"
                        valuePropName='checked'
                    >
                        <Checkbox> </Checkbox>
                    </Form.Item>

                    <Form.Item
                        name="showInParkingPeriod"
                        label="نمایش در دوره پارکینگ"
                        valuePropName='checked'
                    >
                        <Checkbox> </Checkbox>
                    </Form.Item>

                    <Form.Item
                        name="orderIndex"
                        label="ترتیب"
                    >
                        <InputNumber />
                    </Form.Item>


                    <Form.Item
                        name="isActive"
                        label="فعال"
                        valuePropName='checked'
                    >
                        <Checkbox ></Checkbox>
                    </Form.Item>
                </Form>
            </div>
            <Row className='sectionFooter'>
                <Col xs={0} sm={0} md={8} lg={16} xl={16} >
                </Col>
                <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                    <Button
                        style={{ width: '98%' }}
                        className='btn-primary'
                        htmlType="submit"
                        onClick={() => form.submit()}>
                        <CheckOutlined />
                        ذخیره
                    </Button>
                </Col>
                <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                    <Button
                        className='btn-secondary'
                        style={{ width: '100%' }}
                        onClick={() => cancelInsert()}>
                        <RollbackOutlined />
                        لغو </Button>
                </Col>
            </Row>
        </>
    )
}